/* eslint-disable */
// @ts-nocheck

import { useState } from 'react'

import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/20/solid'

import EmptyList from './EmptyList'
import LoadingSpin from './LoadingSpin'
import SearchComponent from './SearchComponent'

interface SelectInTwoTablesInterface {
  data: {
    id: number
    name: string
    addicionalInfo?: string
  }[]
  selectedItems: any[]
  setSelectedItems: Function
  leftTableText?: string
  rigthTableText?: string
  loading?: boolean
  heigthFull?: boolean
}

const SelectInTwoTables = ({
  data,
  selectedItems,
  setSelectedItems,
  leftTableText,
  rigthTableText,
  loading,
  heigthFull,
}: SelectInTwoTablesInterface) => {
  const [search, setSearch] = useState<string | null>(null)

  const handleLeftTableButtonClick = (item: {
    id: any
    name?: string
    addicionalInfo?: string | undefined
  }) => {
    if (selectedItems.filter((elem) => elem.id === item.id).length === 0) {
      setSelectedItems([...selectedItems, item])
    }
  }

  return (
    <>
      <div
        className={`grid grid-cols-1 md:grid-cols-2 ${heigthFull === true ? 'h-full' : 'h-96'} justify-center gap-2 rounded-md pb-4`}
      >
        {!!leftTableText && (
          <h2 className="text-l mt-2 w-full text-center font-normal">
            {leftTableText}
          </h2>
        )}
        {/* Left Table */}
        <div className="overflow-y-auto rounded border border-slate-300 p-2 scrollbar-thin">
          <div className="sticky -top-3 inline-flex w-full gap-x-2 rounded bg-gray-50 p-2">
            <SearchComponent
              findAction={(find: string | null) => setSearch!(find)}
              placeholder="Buscar elemento"
            />
          </div>
          {/* <ProductSelectableList setQuantity={setProductQuantityModal} /> */}
          {loading === true ? (
            <div className="mt-24 flex w-full items-center justify-center">
              <LoadingSpin color="black" />{' '}
            </div>
          ) : data.filter(
              (elem) => !selectedItems.find((elem2) => elem2.id === elem.id)
            ).length === 0 ? (
            <div className="flex h-96 w-full items-center justify-center scrollbar-none">
              <EmptyList size="s" />
            </div>
          ) : (
            <div>
              {search === null || search === '' ? (
                data
                  .filter(
                    (elem) =>
                      !selectedItems.find((elem2) => elem2.id === elem.id)
                  )
                  .map((item, idx) => (
                    <button
                      key={idx}
                      type="button"
                      className={`} my-2 inline-flex w-full items-center rounded-md border border-slate-200 p-5 shadow-md hover:bg-slate-50`}
                      // ${selectedItems.filter(elem => elem.id === item.id).length === 0 ? "bg-white hover:bg-slate-50" : "bg-green-100 hover:bg-g-50"}
                      onClick={() => handleLeftTableButtonClick(item)}
                    >
                      <div className="flex flex-grow flex-col gap-1">
                        <span className="self-start">
                          {/* <ProductTypeBadge type={item.type ?? ""} /> */}
                        </span>
                        <p className="text-md text-start font-semibold">
                          {item.name}
                        </p>
                        <div className="inline-flex items-center gap-5">
                          <p className="block text-start text-sm text-slate-400">
                            {item?.addicionalInfo! ?? ''}
                          </p>
                        </div>
                      </div>
                      <ArrowRightIcon
                        aria-hidden="true"
                        className="text-customBlue-500 h-5 w-5"
                      />
                    </button>
                  ))
              ) : data.filter(
                  (item) =>
                    item.name.includes(search) &&
                    !selectedItems.find((elem2) => elem2.id === item.id)
                ).length > 0 ? (
                data
                  .filter(
                    (item) =>
                      item.name.includes(search) &&
                      !selectedItems.find((elem2) => elem2.id === item.id)
                  )
                  .map((item, idx) => (
                    <button
                      className={`"hover:bg-slate-50" } my-2 inline-flex w-full items-center rounded-md border border-slate-200 p-5 shadow-md`}
                      key={idx}
                      onClick={() => handleLeftTableButtonClick(item)}
                      type="button"
                    >
                      <div className="flex flex-grow flex-col gap-1">
                        <span className="self-start">
                          {/* <ProductTypeBadge type={item.type ?? ""} /> */}
                        </span>
                        <p className="text-md text-start font-semibold">
                          {item.name}
                        </p>
                        <div className="inline-flex items-center gap-5">
                          <p className="block text-start text-sm text-slate-400">
                            {item?.addicionalInfo! ?? ''}
                          </p>
                        </div>
                      </div>

                      <ArrowRightIcon
                        aria-hidden="true"
                        className="text-customBlue-500 h-5 w-5"
                      />
                    </button>
                  ))
              ) : (
                <div className="flex h-96 w-full items-center justify-center scrollbar-none">
                  <EmptyList
                    size="s"
                    title="No hay resultados en la búsqueda"
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* Rigth Table */}
        <div className="overflow-y-auto rounded border border-slate-300 p-2 scrollbar-thin">
          {!!rigthTableText && (
            <h2 className="text-l mt-2 w-full text-center font-normal">
              {rigthTableText}
            </h2>
          )}
          <div className="sticky top-0 rounded p-1 text-sm">
            {loading === true ? (
              <div className="mt-24 flex w-full items-center justify-center">
                <LoadingSpin color="black" />{' '}
              </div>
            ) : selectedItems.length === 0 || selectedItems === null ? (
              <div className="flex h-96 w-full items-center justify-center scrollbar-none">
                <EmptyList size="s" />
              </div>
            ) : (
              selectedItems.map((item, idx) => (
                <button
                  className={`"hover:bg-slate-50"} my-2 inline-flex w-full items-center rounded-md border border-slate-200 p-5 shadow-md`}
                  key={idx}
                  onClick={() =>
                    setSelectedItems(
                      selectedItems.filter((elem) => elem.id !== item.id)
                    )
                  }
                  type="button"
                >
                  <ArrowLeftIcon
                    aria-hidden="true"
                    className="text-customBlue-500 h-5 w-5"
                  />

                  <div className="ml-4 flex flex-grow flex-col gap-1">
                    <span className="self-start">
                      {/* <ProductTypeBadge type={item.type ?? ""} /> */}
                    </span>
                    <p className="text-md text-start font-semibold">
                      {item.name}
                    </p>
                    <div className="inline-flex items-center gap-5">
                      <p className="block text-start text-sm text-slate-400">
                        {item?.addicionalInfo! ?? ''}
                      </p>
                    </div>
                  </div>
                </button>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default SelectInTwoTables
